import { Extension } from '@tiptap/core'

function checkCursorInSlashCommand(editor, storage) {
  if (!editor) return false

  const { selection } = editor.state
  const { empty, $cursor } = selection

  if (!empty || !$cursor) return false

  // Get the current paragraph text
  const currentNode = $cursor.parent
  const text = currentNode.textContent
  const cursorPos = $cursor.parentOffset

  // Find all slash commands in the text
  const slashCommands = []
  const regex = /\/[\w-]*/g
  let match

  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(text)) !== null) {
    slashCommands.push({
      text: match[0],
      start: match.index,
      end: match.index + match[0].length,
    })
  }

  // Check if cursor is within any slash command
  let foundCommand = false
  slashCommands.forEach((cmd) => {
    if (cursorPos >= cmd.start && cursorPos <= cmd.end) {
      const command = cmd.text.slice(1) // Remove the '/' prefix
      const from = $cursor.pos - (cursorPos - cmd.start)
      const to = from + cmd.text.length

      // Store the current command range
      storage.currentRange = { from, to }

      foundCommand = {
        command,
        range: { from, to },
      }
    }
  })

  return foundCommand
}

export function SlashCommand(options = {}) {
  return Extension.create({
    name: 'slashCommandHandler',

    addOptions() {
      return {
        onSlashCommand: options.onSlashCommand || (() => {}),
      }
    },

    addStorage() {
      return {
        isActive: false,
        currentRange: null,
      }
    },

    addKeyboardShortcuts() {
      return {
        '/': ({ editor }) => {
          const { selection } = editor.state
          const { empty, $cursor } = selection

          if (empty && $cursor) {
            const textBefore = $cursor.nodeBefore?.text || ''
            const segments = textBefore.split(' ')
            const lastSegment = segments[segments.length - 1]

            if (!lastSegment || lastSegment === '') {
              this.storage.isActive = true

              setTimeout(() => {
                const currentPos = editor.state.selection.$cursor.pos
                this.storage.currentRange = {
                  from: currentPos - 1,
                  to: currentPos,
                }

                this.options.onSlashCommand({
                  type: 'open',
                  command: '',
                  range: this.storage.currentRange,
                })
              }, 0)
            }
          }
          return false
        },
        ' ': ({ editor }) => {
          const { selection } = editor.state
          const { empty, $cursor } = selection

          if (empty && $cursor && this.storage.isActive) {
            const textBefore = $cursor.nodeBefore?.text || ''
            const segments = textBefore.split(' ')
            const lastSegment = segments[segments.length - 1]

            if (lastSegment === '/') {
              this.storage.isActive = false
              this.options.onSlashCommand({ type: 'close' })
            }
          }
          return false
        },
        'ArrowUp': () => {
          if (this.storage.isActive) {
            this.options.onSlashCommand({ type: 'arrowUp' })
            return true
          }
          return false
        },
        'ArrowDown': () => {
          if (this.storage.isActive) {
            this.options.onSlashCommand({ type: 'arrowDown' })
            return true
          }
          return false
        },
        'ArrowLeft': () => {
          if (this.storage.isActive) {
            this.options.onSlashCommand({ type: 'arrowLeft' })
            return true
          }
          return false
        },
        'ArrowRight': () => {
          if (this.storage.isActive) {
            this.options.onSlashCommand({ type: 'arrowRight' })
            return true
          }
          return false
        },
        'Enter': () => {
          if (this.storage.isActive) {
            this.options.onSlashCommand({ type: 'enter' })
            return true
          }
          return false
        },
        'Escape': () => {
          if (this.storage.isActive) {
            this.storage.isActive = false
            this.options.onSlashCommand({ type: 'close' })
            return true
          }
          return false
        },
      }
    },

    onSelectionUpdate({ editor }) {
      const commandInfo = checkCursorInSlashCommand(editor, this.storage)

      if (commandInfo) {
        if (!this.storage.isActive) {
          this.storage.isActive = true
          this.options.onSlashCommand({
            type: 'open',
            command: commandInfo.command,
            range: commandInfo.range,
          })
        }
        else {
          this.options.onSlashCommand({
            type: 'search',
            command: commandInfo.command,
            range: commandInfo.range,
          })
        }
      }
      else if (this.storage.isActive) {
        this.storage.isActive = false
        this.options.onSlashCommand({ type: 'close' })
      }
    },

    onUpdate({ editor }) {
      if (!editor) return

      const commandInfo = checkCursorInSlashCommand(editor, this.storage)

      if (commandInfo) {
        this.options.onSlashCommand({
          type: 'search',
          command: commandInfo.command,
          range: commandInfo.range,
        })
      }
      else if (this.storage.isActive) {
        this.storage.isActive = false
        this.options.onSlashCommand({ type: 'close' })
      }
    },
  })
}
